import React from 'react';
import { Group, Image, Stack, Text } from '@mantine/core';

type TenantPoweredByStackProps = {
  tenantName: string;
  tenantLogoUrl?: string;
  tenantLogoAltText?: string;
};

/** Header brand lockup: tenant first, TinyPro endorsement second. */
export function TenantPoweredByStack({
  tenantName,
  tenantLogoUrl,
  tenantLogoAltText,
}: TenantPoweredByStackProps): React.ReactElement {
  return (
    <Stack gap={2} align="flex-start">
      {tenantLogoUrl ? (
        <Image
          src={tenantLogoUrl}
          alt={tenantLogoAltText ?? `${tenantName} logo`}
          h={55}
          w="auto"
          fit="contain"
          style={{ maxWidth: 312, paddingLeft: 12, paddingTop: 8 }}
        />
      ) : (
        <Text fw={700} size="sm">
          {tenantName}
        </Text>
      )}

      <Group gap={4} wrap="nowrap" style={{ paddingLeft: 12 }}>
        <Text size="xs" c="dimmed" visibleFrom="sm">
          Powered by
        </Text>
        <Image
          src="/branding/tinypro-logo.png"
          alt="TinyPro"
          h={14}
          w="auto"
          fit="contain"
          style={{ maxWidth: 84 }}
        />
      </Group>
    </Stack>
  );
}
